import React from 'react';

interface CustomButtonProps {
    title: string;
    type: 'button' | 'submit';
    className: string;
    onClick?: () => void;
    disabled?: boolean;
}


export const CustomButton: React.FC<CustomButtonProps> = ({ title, type, className, onClick, disabled }) => {
    return (
        <button type={type} className={className} onClick={onClick} disabled={disabled}>
            {title}
        </button>
    );
};
